/**
 * ChunkLoadError 检测和处理工具
 *
 * 用于处理 K8s 滚动更新时的 chunk 加载失败问题
 */

export const CHUNK_LOAD_ERROR_SESSION_KEY = 'chunk_load_error';

/**
 * 检查是否为 ChunkLoadError
 */
export function isChunkLoadError(error: Error | unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  const errorMessage = error.message || '';
  const errorName = error.name || '';

  return (
    errorName === 'ChunkLoadError' ||
    errorMessage.includes('Loading chunk') ||
    errorMessage.includes('ChunkLoadError') ||
    // webpack 的动态导入失败
    errorMessage.includes('Failed to fetch dynamically imported module')
  );
}

/**
 * 处理 ChunkLoadError：清除缓存并写入 sessionStorage 标记
 *
 * 不执行页面刷新，由 RscVersionFix 组件读取标记后给 RSC 请求加随机参数来刷新资源。
 */
export async function handleChunkLoadError(): Promise<void> {
  console.warn('ChunkLoadError detected, clearing caches and marking session...');

  try {
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
      console.log('All caches cleared');
    }
  } catch (err) {
    console.warn('Failed to clear caches:', err);
  }

  try {
    sessionStorage.setItem(CHUNK_LOAD_ERROR_SESSION_KEY, '1');
  } catch (err) {
    console.warn('Failed to set sessionStorage chunk_load_error flag:', err);
  }
}
